"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3BaseConnector = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const BaseConnector_1 = require("../BaseConnector");
const ethers_1 = require("ethers");
const Web3BaseAdapter_1 = require("../../Adapters/Web3BaseAdapter");
const Adapters_1 = require("../../Adapters");
class Web3BaseConnector extends BaseConnector_1.BaseConnector {
    constructor(nodeUrl, metadata = {
        displayName: "Web3",
        isWallet: false,
        name: "Web3",
    }, config) {
        super(metadata, config);
        this.nodeUrl = nodeUrl;
        this.emitter = new eventemitter3_1.default();
    }
    async _connect() {
        const adapter = new Web3BaseAdapter_1.Web3BaseAdapter(this.config);
        const provider = this.buildWeb3Provider();
        adapter.setProvider(provider);
        const multicall = new Adapters_1.Web3MulticallAdapter(adapter);
        return { adapter, multicall };
    }
    buildWeb3Provider() {
        const protocol = new URL(this.nodeUrl).protocol;
        if (/^http/i.test(protocol)) {
            return new ethers_1.ethers.providers.StaticJsonRpcProvider(this.nodeUrl, this.config.chainId);
        }
        else if (/^ws/i.test(protocol)) {
            return new ethers_1.ethers.providers.WebSocketProvider(this.nodeUrl, this.config.chainId);
        }
        else {
            throw new Error(`Web3BaseConnector does not support ${protocol.slice(0, -1)} protocol`);
        }
    }
}
exports.Web3BaseConnector = Web3BaseConnector;
